import { Route, Routes } from 'react-router-dom';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ToastProvider } from '@/components/ui/toast';
import { ResourceProvider } from '@/contexts/ResourceContext';
import AppRouter from './AppRouter';

function App() {
	return (
		<ToastProvider>
			<TooltipProvider>
				<ResourceProvider>
					<Routes>
						<Route path="/*" element={<AppRouter />} />
					</Routes>
				</ResourceProvider>
			</TooltipProvider>
		</ToastProvider>
	);
}

export default App;
